const ScopeType = {
    COMPANY: 20,
    PARTNER: 40,
    WHOLESALER: 60,
    GLOBAL: 80,
};

export default ScopeType;
